import React, { useEffect } from "react";
import {isMobile} from 'react-device-detect';

const HorizontalAdV2 = (props) => {
    const { adslot, adsizes, adnumber, desktop_adslot, desktop_adsizes } = props;
 useEffect(() => {
    window.googletag = window.googletag || { cmd: [] };

    window.googletag.cmd.push(function () {
        if (isMobile) {
            window.googletag.defineSlot(adslot, adsizes, 'gpt-passback-' + adnumber)
                .addService(window.googletag.pubads());
        } else {
            window.googletag.defineSlot(desktop_adslot, desktop_adsizes, 'gpt-passback-' + adnumber)
                .addService(window.googletag.pubads());
        }

        window.googletag.enableServices();
    });

}, []);

    useEffect(() => {
        if (window.googletag) {
            window.googletag.cmd.push(function () {
                window.googletag.display('gpt-passback-'+adnumber);
            });
        }
    }, []);

    return (
        <div className="desktop_ads_block text-center" style={{ backgroundColor: 'white', margin: '10px' }}>
            <div id={`gpt-passback-${adnumber}`}></div>
        </div>
    )
}

export default HorizontalAdV2;